import React, { useContext, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import styles from "../../../Styles/ComponentStyles/MainPages/Member.module.scss"
import globalStyles from "../../../Styles/global.module.scss"

import { Avatar, Box, IconButton, Pagination, PaginationItem, Stack, Tooltip, Typography } from '@mui/material';
import GlobalSelect from '../../../Utils/Layout/GlobalSelect/GlobalSelect';
import GlobalButton from '../../../Utils/Layout/GlobalButton/GlobalButton';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid';
import { MemberContext, MemberContextPayload } from '../../../Context/MemberDetailsContext';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../Context/GlobalUserDetailContext';
import { useSnackbar } from '../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import agent from '../../../Services/api';
import GlobalDialog from '../../../Utils/Layout/GlobalDialog/GlobalDialog';
import AcrylicNewMemberDialog from './AcrylicDialogs/AcrylicNewMemberDialog';
import deleteIcon from "../../../Assets/Member/Delete-Icons.svg"
import { useSearchParams } from 'react-router-dom';
import GlobalAutocomplate from '../../../Utils/Layout/GlobalAutocomplate/GlobalAutoComplate';
import GlobalWarningDialog from '../../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import { memberListResponseModel } from '../../../models/memberAxiosModels';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const AcrylicTeam = () => {

    const {
        acrylicTeamListDetails,
        setAcrylicTeamListDetails,

        setMemberUserListDetails,
        memberUserListDetails,

        memberPayloadDetails,
        setMemberPayloadDetails
    } = useContext(MemberContext) as MemberContextPayload

    const {
        flagLoader,
        setFlagLoader,

        userProfileDetails
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const { showSnackbar } = useSnackbar();
    const capitalize = (str: string | undefined | null) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";
    const isProfileAdmin = userProfileDetails?.user?.flagAdmin

    const [flagOpenNewMemberDialog, setFlagOpenNewMemberDialog] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedUserId, setSelectedUserId] = useState<number | "">("");
    const [flagDeleteTeamMemberDialog, setFlagDeleteTeamMemberDialog] = useState<any>(false);
    const [storedExistingMemberDetails, setStoredExistingMemberDetails] = useState<{
        fullName: string;
        teamId: number;
    } | null>(null);
    const [uploadFileId, setUploadFileId] = useState<number | null>(null)

    useEffect(() => {
        const paramUserId = searchParams.get("userId");
        const userIdFromURL = paramUserId ? Number(paramUserId) : null;
        const effectiveUserId = userIdFromURL ?? userProfileDetails?.user?.userId ?? null;

        setSelectedUserId(effectiveUserId || "");
        initializeAcrylicTeamListAuth(effectiveUserId);
        initializeAuth();
    }, []);

    const initializeAuth = async () => {
        setFlagLoader(true);
        const response = await agent.getUsersListDetailsApi.get();
        if (response?.status && response?.data) {
            const userResponse = {
                ...response.data,
                users: response.data.users.map((item: any, index: number) => ({
                    ...item,
                    sequenceNumber: index
                }))
            };
            setMemberUserListDetails(userResponse);
            setFlagLoader(false);
        }
        else {
            setFlagLoader(false);
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
        }
    };

    const initializeAcrylicTeamListAuth = async (userId: number | null = null) => {
        const payload = {
            assignedToUserId: userId ?? null,
            flagGetAll: userId === null
        };

        setFlagLoader(true);
        const response = await agent.getAcrylicTeamMemberApi.get(payload);
        console.log("response of getAcrylicTeamMemberApi", response);

        if (response?.status && response?.data) {
            const originalList = response.data;
            // Add sequenceNumber only to default items
            let sequence = 1;
            const enrichedList = originalList.map((item: any) => {
                if (item.isDefault) {
                    return { ...item, sequenceNumber: sequence++ };
                }
                return { ...item, sequenceNumber: null };
            });
            setAcrylicTeamListDetails(enrichedList);
            setFlagLoader(false);
            setSearchParams((prev) => {
                if (userId) {
                    prev.set("userId", userId.toString());
                }
                else {
                    prev.delete("userId");
                }
                return prev;
            });
        }
        else {
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false);
        }
    };

    const columns: any = [
        {
            field: '',
            headerName: '',
            flex: 1,
            // align: "center",
            width: 90,
            minWidth: 90,
            maxWidth: 90,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params: any) => {
                const isDefault = params.row.isDefault;
                if (!isDefault) return null;

                // Get only default items and find current item's position
                const defaultItems = acrylicTeamListDetails.filter(item => item.isDefault);
                const currentIndex = defaultItems.findIndex(item => item.teamId == params.row.teamId);

                // Check if it's first or last among default items
                const isFirstDefault = currentIndex == 0;
                const isLastDefault = currentIndex == defaultItems.length - 1;
                return (
                    <>
                        {isDefault &&
                            <Grid size={{ xs: 12 }} onClick={(e) => { e.stopPropagation(); }}>
                                <Grid container sx={{ gap: "3px", justifyContent: 'center' }}>
                                    <Grid>
                                        {!isFirstDefault && (
                                            <Tooltip
                                                title="Move Up"
                                                arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: '#0087FF',
                                                            fontSize: '10px',
                                                            maxWidth: 300
                                                        }
                                                    },
                                                    arrow: { sx: { color: '#0087FF' } }
                                                }}
                                            >
                                                <IconButton
                                                    className={`${styles.iconHovering}`}
                                                    onClick={(e) => { e.stopPropagation(); moveRow("up", params.row.teamId) }}
                                                >
                                                    <PlayArrowIcon
                                                        className={styles.upArrow}
                                                        sx={{ fontSize: "23px", color: "white" }}

                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Grid>
                                    <Grid>
                                        {!isLastDefault && (
                                            <Tooltip
                                                title="Move Down"
                                                arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: '#0087FF',
                                                            fontSize: '10px',
                                                            maxWidth: 300
                                                        }
                                                    },
                                                    arrow: { sx: { color: '#0087FF' } }
                                                }}
                                            >
                                                <IconButton
                                                    className={`${styles.iconHovering}`}
                                                    onClick={(e) => { e.stopPropagation(); moveRow("down", params.row.teamId) }}
                                                >
                                                    <PlayArrowIcon
                                                        className={styles.downArrow}
                                                        sx={{ fontSize: "23px", color: "white" }}
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        }
                    </>
                )
            }
        },
        {
            field: 'image',
            headerName: 'IMAGE',
            flex: 1,
            width: 80,
            minWidth: 80,
            maxWidth: 80,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params: any) => {
                const image = params.row.image ? params.row.image : "";
                return (
                    <Avatar
                        src={image}
                        sx={{ width: 30, height: 30 }}
                    />
                )
            }
        },
        {
            field: 'firstName',
            headerName: 'FULL NAME',
            minWidth: 280,
            maxWidth: 320,
            flex: 1,
            valueGetter: (params: any) => {
                const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                const firstName = capitalize(params.row?.firstName || '');
                const lastName = capitalize(params.row?.lastName || '');
                return `${firstName} ${lastName}`.trim();
            },
            renderCell: (params: any) => {
                const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
                const firstName = capitalize(params.row?.firstName || '');
                const lastName = capitalize(params.row?.lastName || '');
                const fullName = `${firstName} ${lastName}`.trim();

                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: "default" }}>
                        <span>{fullName}</span>
                        {params.row.isDefault && (
                            <span
                                style={{
                                    fontSize: '12px',
                                    padding: '2px 8px',
                                    border: '1px solid #7ED957',
                                    borderRadius: '12px',
                                    color: '#7ED957',
                                    fontWeight: 500,
                                    backgroundColor: '#1F2A37',
                                }}
                            >
                                Default
                            </span>
                        )}
                    </div>
                );
            },
        },
        {
            field: 'memberTitle',
            headerName: 'TITLE',
            flex: 1,
            minWidth: 150,
            maxWidth: 220,
        },
        {
            field: 'memberEmail',
            headerName: 'Email',
            flex: 1,
            minWidth: 320,
            maxWidth: 350,
        },
        {
            field: 'memberPhone',
            headerName: 'PHONE',
            flex: 1,
            minWidth: 200,
            maxWidth: 200
        },
        {
            field: 'description',
            headerName: 'DESCRIPTION',
            flex: 1,
            width: 300,
            minWidth: 300,
        },
        {
            field: 'action',
            headerName: '',
            minWidth: 50,
            maxWidth: 50,
            width: 50,
            align: "right",
            headerAlign: "right",
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params: any) => {
                const isDefault = params.row.isDefault;
                const isAdmin = isProfileAdmin;

                // If not admin and this row is default, don't render delete button at all
                if (!isAdmin && isDefault) return null;
                return (
                    <>
                        <IconButton onClick={(e) => {
                            e.stopPropagation();
                            setStoredExistingMemberDetails({
                                teamId: params.row.teamId,
                                fullName: `${params.row.firstName} ${params.row.lastName}`
                            });
                            setFlagDeleteTeamMemberDialog(true);
                        }}>
                            <Tooltip
                                title="Delete"
                                arrow
                                placement="bottom"
                                componentsProps={{
                                    tooltip: { className: globalStyles.globalTooltipStyle },
                                    arrow: { className: globalStyles.globalTooltipArrowStyle },
                                }}
                            >
                                <img src={deleteIcon} alt="" style={{ width: '30px', height: '30px' }} />
                            </Tooltip>
                        </IconButton>
                    </>
                )
            }

        }
    ];

    const CustomToolbar = () => (
        <GridToolbarContainer
            sx={{
                color: '#fff',
                marginBottom: '10px',
                '& .MuiButtonBase-root': {
                    color: '#fff',
                    fontWeight: 500,
                    fontSize: '14px',
                    textTransform: 'uppercase',
                },
            }}
        >
            <GridToolbarColumnsButton />
            <GridToolbarFilterButton />
            <GridToolbarDensitySelector />
            <GridToolbarExport />
        </GridToolbarContainer>
    );

    const handleDeleteMember = async () => {
        if (!storedExistingMemberDetails?.teamId) return;

        setFlagLoader(true);

        let payload = {
            acrylicTeamId: storedExistingMemberDetails.teamId
        }

        const response = await agent.deleteAcrylicTeamApi.delete(payload);
        if (response?.status) {
            const successmessage = response?.message || 'Acrylic team deleted successfully!';
            showSnackbar(successmessage, 'success');
            const passUserId = selectedUserId ? selectedUserId : null
            initializeAcrylicTeamListAuth(passUserId);
            setFlagLoader(false);
        }
        else {
            const errorMessage = response?.data?.error?.message || "Something went wrong!";
            showSnackbar(errorMessage, "error");
            setFlagLoader(false);
        }
        setFlagDeleteTeamMemberDialog(false);
        setStoredExistingMemberDetails(null);
    };

    const NoDataOverlay = () => (
        <Box
            sx={{
                textAlign: 'center',
                width: '100%',
                color: '#ccc',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            No Data Found!
        </Box>
    );

    const moveRow = async (direction: "up" | "down", teamId: number) => {
        // Create a copy of the current list
        const listCopy = [...acrylicTeamListDetails];

        // Find the item to move
        const itemIndex = listCopy?.findIndex((row) => row.teamId == teamId && row.isDefault);
        if (itemIndex === -1) return;

        // Calculate target index
        const targetIndex = direction === "up" ? itemIndex - 1 : itemIndex + 1;

        // Find the bounds for default items only
        const defaultItems = listCopy?.filter(item => item.isDefault);
        const defaultItemIndex = defaultItems?.findIndex(item => item.teamId == teamId);
        const targetDefaultIndex = direction == "up" ? defaultItemIndex - 1 : defaultItemIndex + 1;

        // Check bounds within default items
        if (targetDefaultIndex < 0 || targetDefaultIndex >= defaultItems.length) return;

        // Find the target item in the full list
        const targetItem = listCopy?.find(item => item.teamId == defaultItems[targetDefaultIndex].teamId);
        const targetItemIndex = listCopy?.findIndex(item => item.teamId == defaultItems[targetDefaultIndex].teamId);

        if (targetItemIndex === -1) return;

        // Swap the items in the full list
        [listCopy[itemIndex], listCopy[targetItemIndex]] = [listCopy[targetItemIndex], listCopy[itemIndex]];

        // Update sequence numbers for default items only
        let sequence = 1;
        const updatedList = listCopy?.map((item) => {
            if (item.isDefault) {
                return {
                    ...item,
                    sequenceNumber: sequence++
                };
            }
            return item;
        });

        setAcrylicTeamListDetails(updatedList);
        try {
            const response = await handleTeamOrdering(updatedList);
            if (!response?.status) {
                // If API fails, revert to original state
                setAcrylicTeamListDetails(acrylicTeamListDetails);
                showSnackbar("Unable to reorder team. Please try again.", "error");
            }
        }
        catch (error) {
            // If API fails, revert to original state
            setAcrylicTeamListDetails(acrylicTeamListDetails);
            showSnackbar("Unable to reorder team. Please try again.", "error");
        }
    };

    const handleTeamOrdering = async (teamList: any[]) => {
        try {
            const payload = teamList?.filter((item) => item.isDefault)?.map((item) => ({
                acrylicTeamId: Number(item.teamId),
                sequenceNumber: item.sequenceNumber,
            }));

            const response = await agent.updateAcrylicTeamOrderApi.put(payload);
            return response;
        } catch (error) {
            console.error("Ordering failed", error);
            return { status: false };
        }
    };

    return (
        <>

            {flagOpenNewMemberDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="md"
                    dialogHead={
                        !!memberPayloadDetails?.teamId
                            ? `${capitalize(memberPayloadDetails?.firstName)} ${capitalize(memberPayloadDetails?.lastName)}`
                            : "New Member"
                    }
                    open={flagOpenNewMemberDialog}
                    view={
                        <AcrylicNewMemberDialog
                            flagOpenNewMemberDialog={flagOpenNewMemberDialog}
                            setFlagOpenNewMemberDialog={setFlagOpenNewMemberDialog}
                            selectedDropdownUser={selectedUserId}
                            isEditMode={!!memberPayloadDetails?.teamId}
                            initializeAcrylicTeamListAuth={initializeAcrylicTeamListAuth}
                            onSaveSuccess={(newUserId: any) => {
                                setSelectedUserId(newUserId); // update parent state
                                initializeAcrylicTeamListAuth(newUserId); // reload API
                            }}
                        />
                    }
                    onClose={() => { setFlagOpenNewMemberDialog(false) }}
                />
            }

            {flagDeleteTeamMemberDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    open={flagDeleteTeamMemberDialog}
                    maxWidth="sm"
                    dialogHead={'Delete Confirmation'}
                    onClose={() => setFlagDeleteTeamMemberDialog(false)}
                    view={
                        <GlobalWarningDialog
                            popupDescription={`Are you sure you want to delete ${storedExistingMemberDetails?.fullName}?`}
                            primaryButtonText={"Delete"}
                            secondaryButtonText={"Cancel"}
                            primaryButtonWidth="175px"
                            secondaryButtonWidth="175px"
                            onDelete={handleDeleteMember}
                            handleClose={() => setFlagDeleteTeamMemberDialog(false)}
                        />
                    }
                />
            }


            <Grid container>
                <Grid size={{ xs: 12 }} className={styles.atMainItem}>
                    <Grid container>
                        <Grid size={{ xs: 12 }}>
                            <Grid container>
                                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}>
                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV20} `}>
                                        Acrylic Team
                                    </Typography>
                                </Grid>
                                <Grid size={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }} className={`${styles.acrylicTeamContentHeader}`}>
                                    <Grid container sx={{ justifyContent: 'end', gap: "20px", alignItems: "center" }}>
                                        <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 12 }}>
                                            <GlobalAutocomplate
                                                size="small"
                                                fullWidth
                                                placeholder="Select Email"
                                                sx={{ maxHeight: 300 }}
                                                options={memberUserListDetails?.users?.map((ele) => ({ label: ele.email, value: ele.userId })) || []}
                                                value={memberUserListDetails?.users?.map((ele) => ({ label: ele.email, value: ele.userId }))?.find((opt) => opt.value == selectedUserId) || null}
                                                onChange={(event, newValue) => {
                                                    const selectedId = (newValue as any)?.value || null;
                                                    setSelectedUserId(selectedId);
                                                    setSearchParams((prev) => {
                                                        if (selectedId) {
                                                            prev.set("userId", selectedId.toString());
                                                        }
                                                        else {
                                                            prev.delete("userId");
                                                        }
                                                        return prev;
                                                    });
                                                    initializeAcrylicTeamListAuth(selectedId);
                                                }}
                                            />
                                        </Grid>
                                        <Grid size={{ xl: 2, lg: 2, md: 2, sm: 2, xs: 12 }} className={styles.atCloseBtnStyleItem}>
                                            <GlobalButton
                                                fullWidth
                                                value='Add Member'
                                                size='medium'
                                                className={styles.atCloseBtnStyle}
                                                startIcon={<AddIcon />}
                                                onClick={() => {
                                                    setFlagOpenNewMemberDialog(true)
                                                    setMemberPayloadDetails({
                                                        teamId: null,
                                                        userId: selectedUserId,
                                                        firstName: "",
                                                        lastName: "",
                                                        memberTitle: "",
                                                        memberEmail: "",
                                                        memberPhone: "",
                                                        image: 0,
                                                        isDefault: false,
                                                        description: ""
                                                    })
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Grid container>
                                <Grid size={{ xs: 12 }} sx={{ margin: "5px 0px 0px", height: "calc(100vh - 235px)" }}>
                                    <DataGrid
                                        rows={acrylicTeamListDetails}
                                        columns={columns}
                                        density='standard'
                                        getRowId={(row) => row.teamId}
                                        className={`${globalStyles.globalDatagridStyles}  ${styles.userTableStyles}`}
                                        checkboxSelection={false}
                                        disableRowSelectionOnClick
                                        rowHeight={50}
                                        columnHeaderHeight={50}
                                        slots={{
                                            toolbar: CustomToolbar,
                                            noRowsOverlay: NoDataOverlay
                                        }}
                                        rowCount={acrylicTeamListDetails?.length}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { pageSize: 20, page: 0 }
                                            }
                                        }}
                                        pageSizeOptions={[10, 20, 30, 100]}
                                        onRowClick={(params) => {
                                            const rowData = params.row;
                                            // Prevent non-admins from clicking on default rows
                                            if (!isProfileAdmin && rowData.isDefault) return;

                                            // Fallback to selected dropdown user if assignedToUserId is null
                                            const resolvedUserId = rowData?.assignedToUserId ?? selectedUserId ?? null;
                                            // setSelectedUserId(resolvedUserId);
                                            setMemberPayloadDetails({
                                                assignedToUserId: rowData?.assignedToUserId ?? resolvedUserId,
                                                userId: resolvedUserId,
                                                teamId: rowData?.teamId ?? null,
                                                firstName: rowData?.firstName ?? "",
                                                lastName: rowData.lastName ?? "",
                                                memberTitle: rowData.memberTitle ?? "",
                                                memberEmail: rowData.memberEmail ?? "",
                                                memberPhone: rowData.memberPhone ?? "",
                                                description: rowData.description ?? "",
                                                image: rowData.image ?? 0,
                                                isDefault: rowData.isDefault ?? false
                                            });
                                            setFlagOpenNewMemberDialog(true);
                                        }}
                                        sx={{
                                            '& .clickable-row': { cursor: 'pointer' },
                                            '& .non-clickable-row': { cursor: 'default !important' },
                                            '& .MuiToolbar-root': { minHeight: '45px !important' },
                                            '& .MuiDataGrid-row:hover': {
                                                backgroundColor: '#939ba354',
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AcrylicTeam